import { Injectable } from '@angular/core';
import { ApiService } from '../../services/common/api.service';

@Injectable()
export class SuKienService {

  APIURL = "api/ExcuteOracle";
  constructor(private api:ApiService) { 

  }

  getDanhSachSuKien(sukien) {
    var param = {
      "config": '{"namesql":"PKG_TAIKHOAN.P_LAY_DANHMUC_HOATDONG"}',
      "para": '{"v_SUKIEN":"' + sukien + '"}'
    };
    return this.api.Excute(this.APIURL,param);
  }

}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/common/sukien.service.ts